import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./Header.scss"

class Header extends Component {
  constructor() {
    super()
    this.state = {
      showShareOptions: false,
      isScrolled: false
    }
    this.shareBTN = this.shareBTN.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isScrolled: (window.scrollY > 0.10 * window.screen.width ? true : false)
      })
    })
  }
  shareBTN(action) {
    var shareText = "שאלנו אתכם מהן הפלאפליות האהובות עליכם - והצפתם אותנו בתשובות. עכשיו תורכם להכריע, איפה מסתתרות המנות הטובות ביותר?";
    var url = "https://z.ynet.co.il/mShort/commerce/2018/ManaFalafel/";
    switch (action) {
      default:
      case "facebook":
        push("Share_Facebook", url);
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        push("Share_Twitter", url);
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        push("Share_WhatsApp", url);
        window.open("whatsapp://send?text=" + encodeURIComponent(shareText + " >> " + url), "_parent");
        break;
      case "negishut":
        push("Accessibility", "Open_Accessibility_Clicked");
        window.document.getElementById('INDmenu-btn').click();
        break;
      case "sharer":
        this.setState({ 
          showShareOptions: !this.state.showShareOptions
        })
        break;
    }
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className={`share${(this.state.showShareOptions ? " active" : "")}`}>
                <div onClick={() => { this.shareBTN("twitter") }} className="twitter"></div>
                <div onClick={() => { this.shareBTN("whatsapp") }} className="whatsapp"></div>
                <div onClick={() => { this.shareBTN("facebook") }} className="facebook"></div>
                <div onClick={() => { this.shareBTN("sharer") }} className="sharer"></div>
                <div onClick={() => { this.shareBTN("negishut") }} className="negishut"></div>
              </div>
              <div className="logos">
                <a href="https://www.ynet.co.il/" title="ynet" target="_blank"><div className="ynetlogo"></div></a>
                <div className={`text${(this.state.isScrolled ? " active" : "")}`}>
                  המנה של המדינה
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtual-header"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js